var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":['cancel'],"loading":_vm.loading,"title":"Laudos importados","extraLarge":""}},[_c('Form',{ref:"Form",attrs:{"item":_vm.item,"multiple":_vm.multiple}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }